import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import usePagination from "@/views/components/pagination/usePagination";
import { reactive, ref, watch } from "@vue/composition-api";

export default function useBaseTable() {
  const { pagination, onPageChange, onFilterEntity } = usePagination();
  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable();

  const loading = reactive({
    tableData: false,
    tableOverlay: false,
  });
  const fields = ref([]);
  const tableData = reactive({
    payload: [],
  });

  const actionTable = reactive({
    fetchPayload: () => {},
    callBackPagination: () => {},
    callBackFilter : () => {}
  });

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        actionTable.fetchPayload();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      actionTable.fetchPayload();
    },
    { deep: true }
  );

  return {
    pagination,
    onPageChange,
    onFilterEntity,

    loading,
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,

    fields,
    tableData,
    actionTable,
  };
}
